var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import FileUploadOutlined from '@mui/icons-material/FileUploadOutlined';
import { Typography } from '@mui/material';
import { omit } from 'lodash';
import DocumentUploadButton from '../../DocumentUploadButton';
var VASDocumentUpload = function (_a) {
    var _b, _c, _d;
    var documentLabel = _a.documentLabel, documentDesc = _a.documentDesc, uploadButtonProps = _a.uploadButtonProps, className = _a.className;
    return (React.createElement("div", { className: "lfc-border lfc-border-gray-300 lfc-rounded lfc-flex lfc-justify-between lfc-items-center ".concat(className !== null && className !== void 0 ? className : '') },
        React.createElement("div", null,
            React.createElement(Typography, { variant: "subtitle1", className: "lfc-text-gray-900" }, documentLabel !== null && documentLabel !== void 0 ? documentLabel : ''),
            React.createElement(Typography, { variant: "caption1", className: "lfc-text-gray-700" }, documentDesc)),
        React.createElement(DocumentUploadButton, __assign({ buttonProps: __assign(__assign({}, uploadButtonProps.buttonProps), { variant: 'outlined', startIcon: (React.createElement(FileUploadOutlined, { className: "lfc-h-5 lfc-w-5 ".concat(((_b = uploadButtonProps.buttonProps) === null || _b === void 0 ? void 0 : _b.disabled) ? 'lfc-text-gray-700' : 'lfc-text-primary-500') })), className: "lfc-border ".concat(((_c = uploadButtonProps.buttonProps) === null || _c === void 0 ? void 0 : _c.disabled)
                    ? 'lfc-bg-gray-100 lfc-border-gray-500'
                    : 'lfc-bg-primary-50 lfc-border-primary-500', "  lfc-py-2 lfc-px-4"), children: (React.createElement(Typography, { variant: "body2", className: "".concat(((_d = uploadButtonProps.buttonProps) === null || _d === void 0 ? void 0 : _d.disabled) ? 'lfc-text-gray-700' : 'lfc-text-primary-500') }, "Upload")) }) }, omit(uploadButtonProps, ['buttonProps'])))));
};
export default VASDocumentUpload;
//# sourceMappingURL=VASDocumentUpload.js.map